import { trackEvent } from "common/AppInsights/AppInsights";
import { AppDispatch } from "features";
import { AppState } from "features/state";
import { actionCreators } from "../reducers";
import { getOrdersState } from "../selectors";

export const showMorePaymentParties = () => async (dispatch: AppDispatch, getState: () => AppState) => {
    const { closedPaymentPartiesPage } = getOrdersState(getState());
    trackEvent(
        {
            name: "ORDER/SHOW_MORE_CLICKED_PAYMENT_PARTIES",
        },
        {
            request_x: closedPaymentPartiesPage,
        }
    );
    dispatch(actionCreators.closedPaymentPartiesNextPage());
};
